module.exports = __webpack_public_path__ + "img/logoBlack.ccfcb9a0.svg";